// Activated in V5.2
async function getLocalizationSuggestion() {
  try {
    const response = await fetch(
      window.Shopify.routes.root +
        "browsing_context_suggestions.json" +
        "?country[enabled]=true" +
        `&country[exclude]=${window.Shopify.country}` +
        "&language[enabled]=true" +
        `&language[exclude]=${window.Shopify.language}`
    );
    if (!response.ok) {
      throw new Error("Network request failed");
    }
    const { detected_values } = await response.json();
    return {
      detected_country: detected_values.country || { handle: "unknown" },
    };
  } catch (error) {
    console.error("Error in fetching localization suggestion:", error);
    return {
      detected_country: { handle: "unknown" },
    };
  }
}

function setCookie(name, value, daysToExpire) {
  try {
    const expirationDate = new Date();
    expirationDate.setTime(
      expirationDate.getTime() + daysToExpire * 24 * 60 * 60 * 1000
    );
    const expires = "expires=" + expirationDate.toUTCString();
    document.cookie =
      name + "=" + value + ";" + expires + ";path=/;Secure;SameSite=Strict";
  } catch (error) {
    console.error("Error in setting cookie:", error);
  }
}

function getCookie(name) {
  const cookieName = name + "=";
  const cookies = document.cookie.split(";").map((cookie) => cookie.trim());
  const foundCookie = cookies.find((cookie) => cookie.startsWith(cookieName));
  return foundCookie ? foundCookie.substring(cookieName.length) : "";
}

async function showLocalizationSuggestion() {
  const { detected_country } = await getLocalizationSuggestion();

  const isBot = /bot|googlebot|crawler|spider|bingbot|yahoo|baidu|shopifybot|lighthouse|chrome-lighthouse|google page speed/i.test(
    navigator.userAgent
  );
  const isShopifyPreview = window.location.hostname.includes("shopifypreview.com");

  if (isBot || isShopifyPreview) {
    return;
  }

  if (detected_country.handle !== "unknown" && detected_country.handle === "CO") {
    console.log("Redirecting to CO...");
    const currentPath = window.top.location.pathname;
    const currentSearchParams = window.top.location.search;
    const urlParams = new URLSearchParams(currentSearchParams);
    urlParams.set("country", detected_country.handle);

    const newURL =
      "https://entreaguas.com" + currentPath + "?" + urlParams.toString();

    window.top.location.href = newURL;
  }
}

if (
  window.location.search.includes("skipredirect=true") ||
  window.location.search.includes("SkipCozyRedirect=yes")
) {
  setCookie("skipRedirection", "true", 1);
  console.log("Skip Redirect = True");
} else if (getCookie("skipRedirection") === "true") {
  console.log("Skip Redirect = True");
} else {
  showLocalizationSuggestion();
}

// Multi-tier Free Shipping Bar Enhancement
// This enhances the existing free-shipping-bar component with multi-tier functionality
(function() {
  // Wait for DOM to be ready and original component to be defined
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMultiTierBar);
  } else {
    initMultiTierBar();
  }

  function initMultiTierBar() {
    // Check if the element has tier attributes, if so, enhance it
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1 && node.tagName === 'FREE-SHIPPING-BAR') {
            enhanceBar(node);
          }
        });
      });
    });

    // Observe document for new free-shipping-bar elements
    observer.observe(document.body, { childList: true, subtree: true });

    // Enhance any existing bars
    document.querySelectorAll('free-shipping-bar').forEach(enhanceBar);
  }

  function enhanceBar(barElement) {
    // Check if this bar has multi-tier attributes
    if (!barElement.hasAttribute('threshold-tier1')) {
      return; // Not a multi-tier bar, leave it alone
    }

    // Parse all tier thresholds (only enabled ones)
    const tiers = [];
    let tierIndex = 1;
    while (barElement.hasAttribute(`threshold-tier${tierIndex}`)) {
      const isEnabled = barElement.getAttribute(`tier${tierIndex}-enabled`) === 'true';
      
      if (isEnabled) {
        const thresholdAttr = barElement.getAttribute(`threshold-tier${tierIndex}`);
        const threshold = parseFloat(thresholdAttr.replace(/[^0-9.]/g, "")) * 100;
        const benefit = barElement.getAttribute(`tier${tierIndex}-benefit`) || '';
        
        tiers.push({
          threshold,
          benefit
        });
      }
      
      tierIndex++;
    }

    // Sort tiers by threshold
    tiers.sort((a, b) => a.threshold - b.threshold);

    // Store tiers and text settings on the element
    barElement._multiTiers = tiers;
    barElement._allUnlockedText = barElement.getAttribute('all-unlocked-text') || '¡Todos los beneficios desbloqueados!';
    barElement._nextTierTemplate = barElement.getAttribute('next-tier-template') || '¡Ordena {{ amount }} más y recibe {{ benefit }}!';
    barElement._currencyFormatter = new Intl.NumberFormat(Shopify.locale, {
      style: "decimal",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
      useGrouping: true,
    });

    // Override the update method
    const originalUpdateMessage = barElement.constructor.prototype._updateMessage || 
                                  barElement._updateMessage ||
                                  function() {};

    barElement._updateMessage = function() {
      if (!this._multiTiers || this._multiTiers.length === 0) {
        return originalUpdateMessage.call(this);
      }

      const messageElement = this.querySelector("span");
      if (!messageElement) return;

      const totalPrice = this.totalPrice || parseFloat(this.getAttribute("total-price")) || 0;
      const currentTierIndex = getCurrentTierIndex(totalPrice, this._multiTiers);
      let message = "";

      // Calculate progress percentage for the current tier segment
      let progressPercentage = 0;
      if (currentTierIndex === -1) {
        // Working towards first tier
        const firstTier = this._multiTiers[0];
        progressPercentage = Math.min((totalPrice / firstTier.threshold) * 100, 100);
      } else if (currentTierIndex < this._multiTiers.length - 1) {
        // Working towards next tier
        const currentTier = this._multiTiers[currentTierIndex];
        const nextTier = this._multiTiers[currentTierIndex + 1];
        const segmentSize = nextTier.threshold - currentTier.threshold;
        const progressInSegment = totalPrice - currentTier.threshold;
        const segmentProgress = (progressInSegment / segmentSize) * 100;
        
        // Each tier represents a portion of the total bar
        const tierSegmentSize = 100 / this._multiTiers.length;
        const completedTiers = (currentTierIndex + 1) * tierSegmentSize;
        const currentSegmentProgress = (segmentProgress / 100) * tierSegmentSize;
        progressPercentage = Math.min(completedTiers + currentSegmentProgress, 100);
      } else {
        // All tiers complete
        progressPercentage = 100;
      }

      // Update progress bar background
      this.style.setProperty('--progress-percentage', `${progressPercentage}%`);
      if (!this.classList.contains('has-progress')) {
        this.classList.add('has-progress');
      }

      // Build all tier benefits for display
      const allTierBenefits = this._multiTiers.map((tier, index) => {
        const isUnlocked = index <= currentTierIndex;
        const isNext = index === currentTierIndex + 1;
        const formattedAmount = this._currencyFormatter.format(tier.threshold / 100);
        
        return {
          text: tier.benefit,
          amount: formattedAmount,
          unlocked: isUnlocked,
          isNext: isNext
        };
      });

      // Check if all tiers are unlocked
      if (currentTierIndex === this._multiTiers.length - 1) {
        // All unlocked - show celebration message
        const benefitsList = allTierBenefits.map(benefit => benefit.text).join(' ✓ ');
        
        message = `<div class="fsb-message fsb-all-unlocked"><strong class="fsb-title">${this._allUnlockedText}</strong></div><strong class="text-xs fsb-benefits-list">✓ ${benefitsList}</strong></div>`;
      } else {
        // Calculate remaining amount for next tier
        const nextTierIndex = currentTierIndex + 1;
        const nextTier = this._multiTiers[nextTierIndex];
        const remainingAmount = this._currencyFormatter
          .format((nextTier.threshold - totalPrice) / 100)
          .replace(/\$/g, "$$$$");

        // Build message with next tier first, then all benefits on second line
        const nextBenefit = allTierBenefits[nextTierIndex];
        
        // 1. Next tier to unlock with CTA (first line) - use locale template
        const nextTierMessage = this._nextTierTemplate
          .replace('{{ amount }}', remainingAmount)
          .replace('{{ benefit }}', nextBenefit.text);
        const nextTierLine = `<strong class="fsb-next-tier text-xs">${nextTierMessage}</strong>`;
        
        // 2. All benefits (unlocked + unreached) on one line
        const unlockedBenefits = allTierBenefits.filter(benefit => benefit.unlocked);
        const unreachedBenefits = allTierBenefits.filter((benefit, index) => index >= nextTierIndex);
        
        // Build unlocked benefits with checkmarks as separators (no dots)
        const unlockedText = unlockedBenefits.map(b => b.text).join(' ✓ ');
        const unlockedHtml = unlockedText ? `<strong class="fsb-benefits-unlocked">✓ ${unlockedText}</strong>` : '';
        
        // Build unreached benefits with dots as separators
        const unreachedHtml = unreachedBenefits.length > 0 
          ? `<span class="text-subdued fsb-benefits-unreached">${unreachedBenefits.map(b => b.text).join(' · ')}</span>`
          : '';
        
        // Combine with dot separator between sections
        const benefitsHtml = [unlockedHtml, unreachedHtml].filter(s => s).join(' · ');
        const benefitsLine = benefitsHtml ? `<div class="text-xs fsb-benefits-container">${benefitsHtml}</div>` : '';

        message = `<div class="fsb-message fsb-progress">${nextTierLine}${benefitsLine}</div>`;
      }

      messageElement.innerHTML = message;
    };

    // Trigger initial update
    if (typeof barElement._updateMessage === 'function') {
      barElement._updateMessage();
    }
  }

  function getCurrentTierIndex(totalPrice, tiers) {
    // Find the highest tier that has been reached
    for (let i = tiers.length - 1; i >= 0; i--) {
      if (totalPrice >= tiers[i].threshold) {
        return i;
      }
    }
    return -1; // No tiers reached yet
  }
})();